import $ from 'jquery';

$(document).ready(function($) {
    // get the dropdown box value
    var dropdown = document.getElementById("cat");
    // get the current body classes as we use this filter in a few locations
    var body = document.body.classList.toString();
    
    function onCatChange() {
      // I have added the slug to the dropdown options for advice hub because of custom taxonomy
      var dropSlug = $('#cat').find(':selected').attr('data-slug');
      if( dropSlug == 'view-all'){
        // if we are on the testimonials amend the location for this, else advice hub
        if(body.indexOf('template-testimonials') >= 0 || body.indexOf('taxonomy-review_category-data') >= 0){
            location.href = "/testimonials/";
        } else {
            location.href = "/advice-hub/";
        }
      } else if (dropSlug) {
        if(body.indexOf('template-testimonials') >= 0 || body.indexOf('taxonomy-review_category-data') >= 0){
            location.href = "/testimonials/"+dropSlug;
        } else {
            location.href = "/type/"+dropSlug;
        }
      } else if ( dropdown.options[dropdown.selectedIndex].value > 0 ) {
        location.href = "/?cat="+dropdown.options[dropdown.selectedIndex].value;
      } else {
        if(body.indexOf('template-testimonials') >= 0 || body.indexOf('taxonomy-review_category-data') >= 0){
            location.href = "/testimonials/";
        } else {
            location.href = "/advice-hub/";
        }
      }
    }

    $(dropdown).change(function() {
      onCatChange();
    });
    
});